import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import $ from "jquery";
import {
  beginLogout
} from "../../../state/ducks/login/index";

class Menu extends Component {
  beginLogout = () => {
    this.props.beginLogout();
  };

  closeMenu = () => {
    $('#mobilmenu').collapse('hide');
  };

  renderTalimatVer() {
    const { dashboard } = this.props;
    //#if 1
    if (dashboard?.isInstallmentPayment) {
         
            return <Link to="/Home/CreatePayment" className="text-renk-emin" onClick={() => this.closeMenu()}>
            <i className="t-icon-plus-alt" />
            TALİMAT VER
          </Link>;
      
    }
    
    //#else 1
    else {
      if (dashboard?.oneShotPaymentBankType == "0") {
        return <Link to="/Home/CreatePaymentOrder" className="text-renk-emin" onClick={() => this.closeMenu()}>
          <i className="t-icon-plus-alt" />
          TALİMAT VER
        </Link>;
      }
      else if (dashboard?.oneShotPaymentBankType == "1") {
        return <Link to="/Home/CreatePaymentOrderPayFor" className="text-renk-emin" onClick={() => this.closeMenu()}>
          <i className="t-icon-plus-alt" />
          TALİMAT VER
        </Link>;
      }
      else if (dashboard?.oneShotPaymentBankType == "2") {
        return <Link to={{
          pathname: "/Home/CreatePaymentOrderPayTr",
          state: { paymentType: 1 }
        }}
          className="text-renk-emin" onClick={() => this.closeMenu()}>
          <i className="t-icon-plus-alt" />
          TALİMAT VER
        </Link>;
      }
      else if (dashboard?.oneShotPaymentBankType == "3") {
        return <Link to={{
          pathname: "/Home/CreatePaymentOrderEminPay",
          state: { paymentType: 1 }
        }}
          className="text-renk-emin" onClick={() => this.closeMenu()}>
          <i className="t-icon-plus-alt" />
          TALİMAT VER
        </Link>;
      }
    }
  }

  render() {

    const closeMenu = () => {
      $('#mobilmenu').collapse('hide');
    };

    const { dashboard, isCandidateCustomer } = this.props;

    return (
      <>
        {/* Menu item */}
        <li>

          <Link to="/Home/Dashboard" className="text-renk-emin" onClick={() => closeMenu()}>

            <i className="t-icon-home4" />
            ANA SAYFA

          </Link>
        </li>
        {/* Menu item */}
        <li data-toggle="collapse" data-target="#menu1">
          <i className="t-icon-user1" />
          PROFİLİM
          <i className="t-icon-keyboard_arrow_down ml-auto" />
        </li>
        <div id="menu1" className="collapse" data-parent="#sol_menu">
          <ul>
            <li>
              <Link to="/Home/AccountInfo" className="text-renk-emin" onClick={() => closeMenu()}>
                <i className="t-icon-info" />
                BİLGİLERİM
              </Link>
            </li>
            <li>
              <Link to="/Home/AgentInfo" className="text-renk-emin" onClick={() => closeMenu()}>
                <i className="t-icon-user-tie" />
                TEMSİLCİ BİLGİLERİ
              </Link>
            </li>
            <li>
              <Link to="/Home/ResetPassword" className="text-renk-emin" onClick={() => closeMenu()}>
                <i className="t-icon-key-fill" />
                ŞİFRE İŞLEMLERİM
              </Link>
            </li>
          </ul>
        </div>
        {/* Menu item */}
        {!isCandidateCustomer && (
          <li>
            <Link to="/Home/MemberInfo" className="text-renk-emin" onClick={() => closeMenu()}>
              <i className="t-icon-info1" />
              ÜYELİK BİLGİLERİM
            </Link>
            <span className="badge badge-success ml-auto">{dashboard?.menuCount?.memberCount}</span>
          </li>
        )}

        {/* Menu item */}
        {dashboard.hasOwnAgent && (
          <li data-toggle="collapse" data-target="#menu2">
            <i className="t-icon-users1" />
            REFERANSLAR
            <i className="t-icon-keyboard_arrow_down ml-auto" />
          </li>
        )}
        {dashboard.hasOwnAgent && (
          <div id="menu2" className="collapse" data-parent="#sol_menu">
            <ul>
              <li>
                <Link to="/Home/SubmitReference" className="text-renk-emin" onClick={() => closeMenu()}>
                  <i className="t-icon-add" />
                  REFERANS GİRİŞ
                </Link>
              </li>
              <li>
                <Link to="/Home/MyReferences" className="text-renk-emin" onClick={() => closeMenu()}>
                  <i className="t-icon-users1" />
                  REFERANSLARIM
                </Link>
              </li>
              {/* <li>
                <a href="https://www.eminevim.com/tavsiye"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => closeMenu()}>
                  <i className="t-icon-heart-stroke" />
                  KAMPANYALAR
                </a>
              </li>
              <li>
                <Link to="/Home/ReferenceRules" className="text-renk-emin" onClick={() => closeMenu()}>
                  <i className="t-icon-newspaper1" />
                  GEÇERLİLİK KURALLARI
                </Link>
              </li> */}
            </ul>
          </div>
        )}
        {/* Menu item */}
        {dashboard
          && dashboard?.hiddenMenu?.showPaymentOrder ?
          (
            <li data-toggle="collapse" data-target="#menu3">
              <i className="t-icon-clipboard" />
              ÖDEME TALİMATI
              <i className="t-icon-keyboard_arrow_down ml-auto" />
            </li>
          ) : null}
        {dashboard
          && dashboard?.hiddenMenu?.showPaymentOrder ?
          (
            <div id="menu3" className="collapse" data-parent="#sol_menu">
              <ul>
                <li>
                  {this.renderTalimatVer()}
                </li>
                <li>
                  <Link to="/Home/ListPayments" className="text-renk-emin" onClick={() => closeMenu()}>
                    <i className="t-icon-document-fill" />
                    TALİMATLARIM
                  </Link>
                </li>
              </ul>
            </div>
          ) : null
        }

        {/* Menu item */}
        <li>
          <Link to="/Home/SubmitDemand" className="text-renk-emin" onClick={() => closeMenu()}>
            <i className="t-icon-chat-alt-stroke" />
            ÖNERİ VE İSTEK BİLDİRİMİ
          </Link>
        </li>
        {/* Menu item */}
        <li>
          <Link to="/Home/Questions" className="text-renk-emin" onClick={() => closeMenu()}>
            <i className="t-icon-question1" />
            SIKÇA SORULAN SORULAR
          </Link>
        </li>
        {/* Menu item */}
        <li>
          <Link to="/Home/MyDemands" className="text-renk-emin" onClick={() => closeMenu()}>
            <i className="t-icon-search2" />
            TALEP TAKİBİ
          </Link>
          <span className="badge badge-success ml-auto"> {dashboard?.menuCount?.demandCount}</span>
        </li>
        {/* Menu item */}
        <li>
          <a
            href="https://www.eminevim.com/banka-hesap-numaralarimiz"
            target="_blank"
            rel="noopener noreferrer"
            className="text-renk-emin"
            onClick={() => closeMenu()}>
            <i className="t-icon-library" />
            BANKA BİLGİLERİMİZ
          </a>
        </li>
        {/* Menu item */}
        {dashboard.isShowMemberApplication && (
          <li>

            <Link id="hesaplama-yap" to="/Home/SmartCalculation" className="text-renk-emin" onClick={() => closeMenu()}>
              <i className="t-icon-calculator" />
              HESAPLAMA YAP
            </Link>
            <span className="badge badge-success ml-auto">YENİ</span>
          </li>
        )}
        {/* Menu item */}
        {/* <li style={{ border: 0 }}>
          <a
            href="https://esube.eminevim.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-renk-emin"
            onClick={() => closeMenu()}>
            <i className="t-icon-photo_camera_front" />
            GÖRÜNTÜLÜ ŞUBE
          </a>
        </li> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dashboard: selectDashboardInfo(state),
    isCandidateCustomer: state.dashboard.isCandidateCustomer
  };
};
const mapDispatchToProps = dispatch => ({
  beginLogout: () => dispatch(beginLogout())
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
